export default "__VITE_ASSET__DVwIZowN__"